// extracted by mini-css-extract-plugin
export var border = "_m-7";
export var brand = "_m-r";
export var button = "_m-j";
export var center = "_m-9";
export var centered = "_m-5";
export var closeButton = "_m-b";
export var disabledWrapper = "_m-k";
export var error = "_m-n";
export var extraLarge = "_m-4";
export var extraSmall = "_m-1";
export var fill = "_m-g";
export var footer = "_m-f";
export var footerAction = "_m-h";
export var footerButtons = "_m-i";
export var header = "_m-6";
export var icon = "_m-m";
export var info = "_m-q";
export var inline = "_m-8";
export var large = "_m-3";
export var main = "_m-c";
export var modal = "_m-0";
export var neutral = "_m-s";
export var noPadding = "_m-e";
export var none = "_m-t";
export var scrollable = "_m-d";
export var small = "_m-2";
export var success = "_m-p";
export var tight = "_m-l";
export var titleIcon = "_m-a";
export var warn = "_m-o";